import React from 'react';

import { Box, Skeleton, Typography } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import ReportStatus from '../../reportList/components/ReportStatus';

import Breadcrumbs from './Breadcrumbs';
import SupportControlDropdown from './SupportControlDropdown';

const ResponsiveHeader = ({
    handlePrepareEditReport,
    isFetchingReportDetails,
    isVisibleEditButton,
    reportDetails,
}) => (
    <Box
        display="flex"
        flexDirection="column"
        sx={{ display: { md: 'none', xs: 'block' }, p: 2 }}
    >
        <Box display="flex" alignItems="center" gap={2}>
            <ReportStatus iconSize={20} status={reportDetails?.status} />

            {isFetchingReportDetails ? (
                <Skeleton
                    sx={{ fontSize: '1rem', width: '100%' }}
                    variant="text"
                />
            ) : (
                <Typography variant="h4">
                    {get(reportDetails, 'name', null)}
                </Typography>
            )}
            <SupportControlDropdown
                handlePrepareEditReport={handlePrepareEditReport}
                isVisibleEditButton={isVisibleEditButton}
            />
        </Box>

        {isFetchingReportDetails ? (
            <Skeleton sx={{ fontSize: '1rem', width: '100%' }} variant="text" />
        ) : (
            <Breadcrumbs pl={5} reportDetails={reportDetails} />
        )}
    </Box>
);

ResponsiveHeader.propTypes = {
    handlePrepareEditReport: PropTypes.func,
    isFetchingReportDetails: PropTypes.bool,
    isVisibleEditButton: PropTypes.bool,
    reportDetails: PropTypes.object,
};

export default ResponsiveHeader;
